import { render, staticRenderFns } from "./SensorMap2.vue?vue&type=template&id=195a6986"
import script from "./SensorMap2.vue?vue&type=script&lang=js"
export * from "./SensorMap2.vue?vue&type=script&lang=js"
import style0 from "./SensorMap2.vue?vue&type=style&index=0&id=195a6986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports